import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './quasar'
import boot from '@/boot'
import './styles/styles.css'
import 'vue-kit/src/styles/index.styl'
import 'vue-kit/dist/vue-kit.css'
import 'handsontable/dist/handsontable.full.css'

boot()

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
